module.exports = __webpack_public_path__ + "static/media/Lato-Hairline.db15ac79.ttf";